import React from 'react';
import * as S from './styles';

const InputField = (props: any) => {
  const { label, onChange, ...rest } = props;
  return (
    <S.Wrapper>
      <S.Input placeholder={label} onChange={e => onChange(e.target.value)} {...rest} />
    </S.Wrapper>
  );
}

export default InputField;;
